export default __webpack_public_path__ + "static/media/image-product-2.c8bb0aac.jpg";